import React from 'react';
import axios from 'axios';

import AppVars from '../../AppVars.js'
import Logger from '../../Logger.js';
import { constants } from '../../constants/constants';

import EmailVerificationView from '../Views/TO/Activate/EmailVerificationView';
import EmbeddedEmailVerificationView from '../Views/TO/Activate/EmbeddedEmailVerificationView.js';
import {parseCookies, isValidGoToURL} from 'account-portal-library/lib/helperFunctions'
import navigateWithAnalytics from '../../analytics/navigateWithAnalytics.js';

const appVars = AppVars.getInstance();
const logger = Logger.getInstance();

const INPUT_TYPES = {
    "PHONE" : "^(?!0)[0-9]{10}$",
    "EMAIL" : "(^[0-9A-Z_a-z][-0-9A-Z_a-z]*(\\.[-0-9A-Z_a-z]+)*@([0-9A-Z_a-z][-0-9A-Z_a-z]*(\\.[-0-9A-Z_a-z]+)*\\.(AERO|ARPA|BIZ|COM|COOP|EDU|GOV|INFO|INT|LAW|MIL|MOBI|MUSEUM|NAME|NET|ORG|PRO|TRAVEL|aero|arpa|biz|com|coop|edu|gov|info|int|law|mil|mobi|museum|name|net|org|pro|travel|[A-Za-z][A-Za-z])|([0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}))(:[0-9]{1,5})?$)"
}

class EmailVerification extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            ...props,
            email: "",
            successEmail: "",
            loading: false,
            isFormValid: true,
            isUserAlreadyActivated: false,
            activationEmailSent: false,
            userNotFound: false,
            emailFail: false,
            onFocus: false

        }
        this.emailRegex = new RegExp(constants.EMAIL_VALIDATION_REGEX)
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleEmbeddedActivation = this.handleEmbeddedActivation.bind(this);
        this.setFocus = this.setFocus.bind(this);
        this.removeFocus = this.removeFocus.bind(this);
    }

    componentDidMount(){
        logger.log('stage', this.props.login_uri)
        if (this.props.external === true){
            this.setState({email: sessionStorage.AP_SSID})
            logger.log('stage', sessionStorage.AP_SSID)
        }

    }

    handleFormSubmit(event) {
        event.preventDefault()
        // Check first if its valid
        const valid = this.validateInput(this.state.email);
        this.setState({ isFormValid: valid });
        if (valid) {
            // If valid set state to loading while we do our mojo
            this.setState({ loading: true });
            this.sendEmailActivation();
        } else {
            this.setState({
                loading: false,
                isFormValid: valid,
                isUserAlreadyActivated: false,
                activationEmailSent: false,
                userNotFound: false,
                emailFail: false
            })
        }

        
        // this.setState({ loading: true })
    }
    
    handleEmbeddedActivation(event){
        event.preventDefault()
        this.sendEmailActivation(true)

    }

    async sendEmailActivation(external) {
        const parsedCookies = parseCookies(document.cookie);
        let redirectURI;
        if (Object.keys(parsedCookies).includes("login_uri") && isValidGoToURL('T', parsedCookies["login_uri"])){
            redirectURI = parsedCookies["login_uri"]
        }
        else if (Object.keys(parsedCookies).includes("login_uri") && isValidGoToURL('S', parsedCookies["login_uri"])){
            redirectURI = parsedCookies["login_uri"]
        }
        else {
            redirectURI = "/"
        }
        let email;
        if (external ){
            email = sessionStorage.AP_SSID
        } else{
            email = this.state.email.trim()
        }
        /*if (sessionStorage.AP_STYLE === "DG"){
            const xclient = 'SI-REG'
        } else {
            xclient = 'TO-WEB'
        }*/
        const body = {
            'redirectURI' : redirectURI
        }

        /*axios({
            method: 'post',
            data: body,
            // url: '/v2/admin/account/activation/email/' + email,
            url: appVars.getDCS3BaseURL() + '/v2/admin/account/activation/email/' + email,
            headers: {
                'X-API-KEY': await appVars.getAPIKey(),
                'X-BRAND': 'T',
                'X-CLIENT': xclient,
                'X-VERSION': '1.6',
                'Content-Type': 'application/json'
            }
        }).then((resp) => this.handleDCS3Response(resp))
        .catch((err) => this.handleDCS3Error(err))
        */

        /*const params = {
            email: email
        };*/

        const headers = {
            //'X-CLIENT': xclient,
            "x-client" : "FR-Portal-Toyota",
            'X-BRAND': 'T'
        }

        axios({
            method: 'post',
            headers,
            //params,
            data: body,
            url: appVars.getAPIGatewayURL() + "/activation/" + email,

        }).then((resp) => this.handleDCS3Response(resp))
        .catch((err) => this.handleDCS3Error(err))

    }

    handleDCS3Response(resp) {
        // Following along with the DCS3 repo
        const res = resp['data']
        logger.log('stage', res);
        if (res['status']['messages'][1]) {
            if (res['status']['messages'][1]['code'] == constants.USER_ALREADY_ACTIVATED) {
                this.setState({
                    loading: false,
                    isFormValid: true,
                    activationEmailSent: false,
                    userNotFound: false,
                    emailFail: false,
                    isUserAlreadyActivated: true
                })
            }
        } else if (res['status']['messages'][0]) {
            logger.log('stage', res['status']['messages'][0])
            if (res['status']['messages'][0]['code'] == 'M00000') {
                logger.log('stage', 'REQUEST_COMPLETED_SUCCESSFULLY');

                this.setState({
                    loading: false,
                    isFormValid: true,
                    isUserAlreadyActivated: false,
                    userNotFound: false,
                    emailFail: false,
                    activationEmailSent: true,
                    successEmail: this.state.email.trim()
                });
            }
        } else {
            // We got something real werid, go back to defaults
            this.setState({
                loading: false,
                isFormValid: true,
                isUserAlreadyActivated: false,
                activationEmailSent: false,
                userNotFound: false,
                emailFail: false
            })
        }
    }


    handleDCS3Error(err) {
        // Following along with the DCS3 repo
        try{
            if (err.response.status == 404) {
                this.setState({
                    loading: false,
                    isFormValid: true,
                    isUserAlreadyActivated: false,
                    activationEmailSent: false,
                    emailFail: false,
                    userNotFound: true
                })
            } else {
                this.setState({
                    loading: false,
                    isFormValid: true,
                    isUserAlreadyActivated: false,
                    activationEmailSent: false,
                    userNotFound: false,
                    emailFail: true
                })
            }
        }catch{
            this.setState({
                loading: false,
                isFormValid: true,
                isUserAlreadyActivated: false,
                activationEmailSent: false,
                userNotFound: false,
                emailFail: true
            })
        }

    }


    validateInput(email){
        let validEmail;
        if (email == null || email.length === 0 || !email.match(INPUT_TYPES["EMAIL"])) {
            validEmail = false;
        } else {
            validEmail = true;
        }
        this.setState({isFormValid: validEmail});
        return (validEmail)
    }


    handleEmailChange(event) {
        this.setState({email: event.target.value})
        this.setState({isFormValid: null})
    }

    setFocus(event){
        this.setState({onFocus: true})
        this.setState({isFormValid: null})
    }

    removeFocus(){
        if(this.state.email === ""){
            this.setState({onFocus: false})
        }else{
            this.setState({onFocus: true})
        }
    }

    render() {
        if (sessionStorage.AP_STYLE === "TO"){
            navigateWithAnalytics(appVars.getResendActivationEmailURL("TO"), "resend-redirect", "auto");
        } else if (this.props.embedded === false){
        return(
            <EmailVerificationView
            onFocus = {this.state.onFocus}
            email = {this.state.email}
            loading = {this.state.loading}
            successEmail = {this.state.successEmail}
            isFormValid = {this.state.isFormValid}
            activationEmailSent = {this.state.activationEmailSent}
            isUserAlreadyActivated = {this.state.isUserAlreadyActivated}
            userNotFound = {this.state.userNotFound}
            emailFail = {this.state.emailFail}
            handleFormSubmit = {this.handleFormSubmit}
            handleEmailChange = {this.handleEmailChange}
            setFocus = {this.setFocus}
            removeFocus = {this.removeFocus}

            />
        )} else{
            return(
                <EmbeddedEmailVerificationView 
                email = {this.state.email}
                activationEmailSent = {this.state.activationEmailSent}
                handleEmbeddedActivation = {this.handleEmbeddedActivation}
                style = {sessionStorage.AP_STYLE}
                />
            )
        }
    }

    
}

export default EmailVerification